/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="form-search-wrap form-search-static">
    <b-form class="form-search" @submit.prevent="submitForm">
      <b-form-group class="form-search_group text-center">
        <div class="form-search_group_input">
          <button class="btn-icon form-search_close" @click.prevent="resetSearch">
            <svg class="o-icon stroke-black"><use xlink:href="#close"></use></svg>
          </button>
          <base-input
            autocomplete="off"
            classInput="form-search_input"
            :placeholder="$t('Search') + '...'"
            name="searchTextInput"
            v-model.trim="inputText"
            type="text"
            @input="submitForm"
            :autofocus="true"
          >
          </base-input>
        </div>
        <button @click="resetSearch" class="btn btn-bcm-link bcm-link-underline-primary my-4_1">
          {{ $t('Reset') }}
        </button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import BaseInput from 'theme/components/Form/BaseInput'
import debounce from 'lodash/debounce'
import assign from 'lodash/assign'

export default {
  data: () => ({
    inputText: ''
  }),
  methods: {
    submitForm () {
      if (!window.searchThrottle) {
        window.searchThrottle = debounce(this.doSubmit.bind(this), 500)
      }
      window.searchThrottle()
    },
    doSubmit () {
      const newQuery = assign({}, this.$route.query, { q: this.inputText })

      this.$emit('changeQuery', newQuery)
    },
    resetSearch () {
      this.inputText = ''
      this.submitForm()
    }
  },
  mounted () {
    // reset debounce
    window.searchThrottle = undefined
    this.inputText = this.$route.query.q || ''
  },
  components: {
    BaseInput
  }
}
</script>
